import {Food} from "./types";

const SundayMeals: Food = {
    "Taco Salad": {
        "Romain": "3oz",
        "Black Chx": "4oz",
        "Black Beans": "1/4 cup",
        "Corn": "1/8 cup",
        "Sharp Cheddar": "28g",
        "Tortilla Strips": "28g"
    },
    "Sam Salad": {
        "Spring Mix": "2oz",
        "Grilled Chicken": "4oz",
        "Walnuts": "1 & 1/2 tablespoon",
        "Blue Cheese": "14g",
        "Cranberries": "1 & 1/2 tablespoon",
        "Green Apple": "5 - 10 pieces",
        "Sides": "Sweet Onion Dressing"
    },
        "Chicken Caesar Salad": {
        "Diced LH Chx": "4oz",
        "Romaine": "3oz",
        "Parm Cheese": "28g",
        "Garnish": "Lemon Zest",
        "Sides": "Ceaser Dressing and Croutons"
    },
}

export default SundayMeals